module.exports = __webpack_public_path__ + "img/18_5.19f28a1a.png";